import { AppState } from '../../../redux/reducers';
import { ContractNegotiationVersionConcept } from '../../../models/Entities/Contracts/ContractNegotiationVersionConcept';
import * as ContractNegotiationVersionConceptMiddleware from '../../../redux/middleware/ContractNegotiationVersionConceptMiddleware';

export interface OwnProps {
  versionConcept: ContractNegotiationVersionConcept | undefined;
  versionId: string;
  negotiationConceptId: string;
  currencyCode: string | undefined;
  contractId: number;
  contractNegotiationId: string;
  isConceptFinalized: boolean;
}

interface ConnectedProps {
  isUpdating: boolean;
}

interface DispatchProps {
  CreateContractNegotiationVersionConcept: typeof ContractNegotiationVersionConceptMiddleware.actionCreators.CreateContractNegotiationVersionConcept;
  UpdateContractNegotiationVersionConcept: typeof ContractNegotiationVersionConceptMiddleware.actionCreators.UpdateContractNegotiationVersionConcept;
}

export type Props = OwnProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (_state: AppState, ownProps: OwnProps): ConnectedProps => ({
  isUpdating: ownProps.versionConcept?.isUpdating ?? false,
});

export const mapDispatchToProps: DispatchProps = {
  CreateContractNegotiationVersionConcept:
    ContractNegotiationVersionConceptMiddleware.actionCreators.CreateContractNegotiationVersionConcept,
  UpdateContractNegotiationVersionConcept:
    ContractNegotiationVersionConceptMiddleware.actionCreators.UpdateContractNegotiationVersionConcept,
};

// ContractNegotiationConceptStatusEnum
// offered = 1, accepted = 2, rejected = 3, solicited = 4
export const STATUS_OPTIONS = [
  { value: 1, label: 'Ofertado' },
  { value: 2, label: 'Aceptado' },
  { value: 3, label: 'Rechazado' },
  { value: 4, label: 'Solicitado' },
] as const;

export type StatusOptionValue = (typeof STATUS_OPTIONS)[number]['value'];

/** Default status for a counter-offer value */
export const DEFAULT_CONCEPT_STATUS: StatusOptionValue = 4;

export const getStatusLabel = (status: number | undefined): string =>
  STATUS_OPTIONS.find((s) => s.value === status)?.label ?? '-';

export const getStatusColor = (status: number | undefined): string => {
  switch (status) {
    case 1: return 'var(--colorBrandForeground1)';   // offered  – brand blue
    case 2: return 'var(--colorPaletteGreenForeground1)';  // accepted – green
    case 3: return 'var(--colorPaletteRedForeground1)';    // rejected – red
    case 4: return 'var(--colorPaletteYellowForeground1)'; // solicited – amber
    default: return 'var(--colorNeutralForeground3)';
  }
};
